<template>
    <a :href="`/products/${slug}`">
      <i class="ti-eye"></i>
    </a>
</template>

<script>
export default {
  props: ['slug']
}
</script>



// WEBPACK FOOTER //
// src/components/PreviewButton.vue